const desktop = theme => {
  const {toVW} = theme;
  return {
    chipsWrapper: {
      minHeight: 28,
    },
    currentBet: {
      height: 16,
    },
  };
};

const mobile = theme => {
  const {toVW} = theme;
  const chipsWrapperMinWidth = 35;

  return {
    chipsWrapper: {
      minWidth: chipsWrapperMinWidth,
      minHeight: 32,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    currentBet: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 20,
      background: 'rgba(0, 0, 0, 0.25)',
      boxShadow: 'inset 3px 3px 5px rgba(0, 0, 0, 0.455)',
      borderRadius: 5,
      padding: '2px 5px',
      width: 'max-content',
      marginTop: -3,
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
